import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { 
  Typography, 
  TextField, 
  MenuItem,
  Button
} from '@material-ui/core';


import DateFnsUtils from '@date-io/date-fns';
import krLocale from "date-fns/locale/ko";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import Autocomplete from '@material-ui/lab/Autocomplete';

import { SearchInput } from 'components';

import { resultsDevice, typesDevice, statusesDevice } from 'common/datas';
import { IsNoU } from 'common/utils';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  search_input_device_serial: {
    width: 440,
  },
  registerListNameTitle: {
    marginLeft: theme.spacing(2),
    width: '140px',
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '260px',
    //height: '40px',
  },
}));

const DeviceToolbar = props => {
  const { 
    className, 
    userRole,
    type, 
    onClickFindDevice,
    onClickFindDeviceLog,
    onClickDeleteAllDeviceLog,

    onClickFindDeviceErrors,
    onClickDeleteAllDeviceErrors,

    onClickFindDeviceHistory,
    onClickDeleteAllDeviceHistory,

    onClickFindModem,
    onClickFindModemHistory,
    onClickDeleteAllModemHistory,

    selectedStartDate,
    setSelectedStartDate,
    selectedEndDate,
    setSelectedEndDate,

    selectedDeleteStartDate,
    setSelectedDeleteStartDate,
    selectedDeleteEndDate,
    setSelectedDeleteEndDate,

    cars,
    companies,
    ...rest 
  } = props;

  const classes = useStyles();

  const [deviceSerialNo, setDeviceSerialNo] = useState('');
  const [selectedCarNumber, setSelectedCarNumber] = useState('');
  const [selectedCompany, setSelectedCompany] = useState('');
  const [selectedStatus, setSelectedStatus] = useState(statusesDevice[0].value);
  const [selectedInstalled, setSelectedInstalled] = useState(typesDevice[0].value);

  const [selectedResult, setSelectedResult] = useState(resultsDevice[0].value);

  const [selectedTelecom, setSelectedTelecom] = useState('');

  const [modemSerialNo, setModemSerialNo] = useState('');

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      {type === 'manage' && (
        <div>
          <div className={classes.row}>
            <Typography
              className={classes.registerListNameTitle}
              color="textSecondary"
              gutterBottom
            >
              디바이스 시리얼 NO
            </Typography>

            <SearchInput
              className={classes.searchInput}
              placeholder=""
              value={deviceSerialNo}
              onChange={event => setDeviceSerialNo(event.target.value)}
            />
            
          <Button
            color="primary"
            variant="contained"
            onClick={ () => onClickFindDevice(deviceSerialNo, selectedCarNumber, selectedCompany, selectedStatus, selectedInstalled) }
          >
            조회
          </Button>
          
          </div>

          <div className={classes.row}>

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              차량번호
            </Typography>

            <Autocomplete
              id="device-toolbar-manage-car-name-auto"
              options={cars.map(car => car.number)}
              style={{ width: 260 }}
              value={selectedCarNumber}
              onChange={(event, newValue) => {
                setSelectedCarNumber(newValue);
              }}
              renderInput={params => (
                <TextField {...params} 
                  fullWidth 
                  margin="dense" />
              )}
            />

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              택시회사명
            </Typography>

            <Autocomplete
              id="device-toolbar-manage-company-name-auto"
              options={companies.map(company => company.name)}
              style={{ width: 260 }}
              value={selectedCompany}
              onChange={(event, newValue) => {
                setSelectedCompany(newValue);
              }}
              renderInput={params => (
                <TextField {...params} 
                  fullWidth 
                  margin="dense" />
              )}
            />
          </div>

          <div className={classes.row}>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              디바이스 현황
            </Typography>

            <TextField
              className={classes.registerListItemInput}
              id="outlined-select-agency"
              select
              value={selectedStatus}
              onChange={event => setSelectedStatus(event.target.value)}
              helperText=""
              margin="dense"
            >
              {statusesDevice.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              디바이스 상태
            </Typography>
            <TextField
              className={classes.registerListItemInput}
              id="outlined-select-client"
              select
              value={selectedInstalled}
              onChange={event => setSelectedInstalled(event.target.value)}
              helperText=""
              margin="dense"
            >
              {typesDevice.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </div>
        </div>
      )}

      {type === 'logs' && (
        <div>
          <div className={classes.row}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                조회일자
              </Typography>

              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                id="date-picker-inline1"
                value={selectedStartDate}
                onChange={date => setSelectedStartDate(date)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />

              <Typography
                className={classes.registerListItemDateGap}
                color="textSecondary"
                gutterBottom
              >
                ~
              </Typography>

              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                id="date-picker-inline2"
                value={selectedEndDate}
                onChange={date => {
                  setSelectedEndDate(date);
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />

              </MuiPickersUtilsProvider>
            
            <Button
              color="primary"
              variant="contained"
              onClick={ () => onClickFindDeviceLog(
                selectedStartDate, 
                selectedEndDate, 
                (selectedCarNumber && selectedCarNumber.length > 0) ? selectedCarNumber : undefined, 
                (selectedCompany && selectedCompany.length > 0) ? selectedCompany : undefined, 
                selectedResult !== resultsDevice[0].value ? selectedResult : undefined
                ) 
              }
            >
              조회
            </Button>
          
          </div>

          <div className={classes.row}>

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              차량번호
            </Typography>

            <Autocomplete
              id="device-toolbar-logs-car-name-auto"
              options={cars.map(car => car.number)}
              style={{ width: 260 }}
              value={selectedCarNumber}
              onChange={(event, newValue) => {
                setSelectedCarNumber(newValue);
              }}
              renderInput={params => (
                <TextField {...params} 
                  fullWidth 
                  margin="dense" />
              )}
            />

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              택시회사명
            </Typography>
            <Autocomplete
              id="device-toolbar-manage-company-name-auto"
              options={companies.map(company => company.name)}
              style={{ width: 260 }}
              value={selectedCompany}
              onChange={(event, newValue) => {
                setSelectedCompany(newValue);
              }}
              renderInput={params => (
                <TextField {...params} 
                  fullWidth 
                  margin="dense" />
              )}
            />
          </div>

          <div className={classes.row}>
            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              결과
            </Typography>

            <TextField
              className={classes.registerListItemInput}
              id="outlined-select-agency"
              select
              value={selectedResult}
              onChange={event => setSelectedResult(event.target.value)}
              helperText=""
              margin="dense"
            >
              {resultsDevice.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>

          </div>

          {userRole !== 'user' && (
            <div className={classes.row}>

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                일괄삭제
              </Typography>

              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  id="date-picker-inline3"
                  value={selectedDeleteStartDate}
                  onChange={date => setSelectedDeleteStartDate(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />

                <Typography
                  className={classes.registerListItemDateGap}
                  color="textSecondary"
                  gutterBottom
                >
                  ~
                </Typography>

                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  id="date-picker-inline4"
                  value={selectedDeleteEndDate}
                  onChange={date => setSelectedDeleteEndDate(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />

              </MuiPickersUtilsProvider>

              <Button
                style={{
                  backgroundColor: "#E00000",
                  color: "#FFFFFF"
                }}
                variant="contained" 
                onClick={ () => onClickDeleteAllDeviceLog(selectedDeleteStartDate, selectedDeleteEndDate) }
              >
                삭제
              </Button>
            </div>
          )}
        </div>
      )}

      {type === 'errors' && (
        <div>
          <div className={classes.row}>
          <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              차량번호
            </Typography>
            <Autocomplete
              id="device-toolbar-find-car-auto"
              options={cars.map(car => car.number)}
              // getOptionLabel={
              //   option => option.name
              //   //option => option
              // }
              style={{ width: 260 }}
              value={selectedCarNumber}
              onChange={(event, newValue) => {
                //console.log(newValue);
                if (!IsNoU(newValue) && newValue.length > 0) {
                  const selectedCar = cars.find(car => (car.number === newValue));
                  if (!IsNoU(selectedCar)) {
                    setSelectedCompany(selectedCar.company);
                  }
                  else {
                    setSelectedCompany('');
                  }
                }
                else {
                  setSelectedCompany('');
                }
                
                setSelectedCarNumber(newValue);
              }}
              // onChange={event=> setSelectedCompany(event.target.value)}
              renderInput={params => (
                <TextField {...params} 
                  //variant="outlined" 
                  fullWidth 
                  margin="dense" />
              )}
            />

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              택시회사명
            </Typography>
            <TextField 
              className={classes.registerListItemInput}
              id="outlined-basic-reg-campaign-name"
              //variant="outlined" 
              value={selectedCompany}
              //onChange={event=> setAgencyName(event.target.value)}
              disabled={true}
              margin="dense"/>

            <Button
              color="primary"
              variant="contained"
              onClick={ () => onClickFindDeviceErrors(selectedCarNumber, selectedCompany) }
            >
              조회
            </Button>
          
          </div>

          {userRole !== 'user' && (
          <div className={classes.row}>

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              일괄삭제
            </Typography>

            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                id="date-picker-inline5"
                value={selectedDeleteStartDate}
                onChange={date => setSelectedDeleteStartDate(date)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />

              <Typography
                className={classes.registerListItemDateGap}
                color="textSecondary"
                gutterBottom
              >
                ~
              </Typography>

              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                id="date-picker-inline6"
                value={selectedDeleteEndDate}
                onChange={date => setSelectedDeleteEndDate(date)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />

            </MuiPickersUtilsProvider>

            <Button
              style={{
              //  borderRadius: 35,
                backgroundColor: "#E00000",
                color: "#FFFFFF"
                // padding: "18px 36px",
                // fontSize: "18px"
              }}
              variant="contained" 
              //color="inherit"
              onClick={ () => onClickDeleteAllDeviceErrors(selectedDeleteStartDate, selectedDeleteEndDate) }
            >
              삭제
            </Button>
          </div>
          )}
        </div>
      )}

      {type === 'history' && (
        <div>
          <div className={classes.row}>

            <Typography
              className={classes.registerListNameTitle}
              color="textSecondary"
              gutterBottom
            >
              디바이스 시리얼 NO
            </Typography>

            <SearchInput
              className={classes.searchInput}
              placeholder=""
              value={deviceSerialNo}
              onChange={event => setDeviceSerialNo(event.target.value)}
            />
            
            <Button
              color="primary"
              variant="contained"
              onClick={ () => onClickFindDeviceHistory(deviceSerialNo) }
            >
              조회
            </Button>
          
          </div>

          <div className={classes.row}>

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              조회일자
            </Typography>

            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                id="date-picker-inline7"
                value={selectedStartDate}
                onChange={date => setSelectedStartDate(date)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />

              <Typography
                className={classes.registerListItemDateGap}
                color="textSecondary"
                gutterBottom
              >
                ~
              </Typography>

              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                id="date-picker-inline8"
                value={selectedEndDate}
                onChange={date => setSelectedEndDate(date)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />

            </MuiPickersUtilsProvider>

            </div>

            {userRole !== 'user' && (
              <div className={classes.row}>

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                일괄삭제
              </Typography>

              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  id="date-picker-inline9"
                  value={selectedDeleteStartDate}
                  onChange={date => setSelectedDeleteStartDate(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />

                <Typography
                  className={classes.registerListItemDateGap}
                  color="textSecondary"
                  gutterBottom
                >
                  ~
                </Typography>

                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  id="date-picker-inline10"
                  value={selectedDeleteEndDate}
                  onChange={date => setSelectedDeleteEndDate(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />

              </MuiPickersUtilsProvider>

              <Button
                style={{
                //  borderRadius: 35,
                  backgroundColor: "#E00000",
                  color: "#FFFFFF"
                  // padding: "18px 36px",
                  // fontSize: "18px"
                }}
                variant="contained" 
                //color="inherit"
                onClick={ () => onClickDeleteAllDeviceHistory(selectedDeleteStartDate, selectedDeleteEndDate) }
              >
                삭제
              </Button>
            </div>
          )}
        </div>
      )}


      {type === 'modem' && (
        <div>
          <div className={classes.row}>

            <Typography
              className={classes.registerListNameTitle}
              color="textSecondary"
              gutterBottom
            >
              모뎀 시리얼 NO
            </Typography>

            <SearchInput
              className={classes.searchInput}
              placeholder=""
              value={modemSerialNo}
              onChange={event => setModemSerialNo(event.target.value)}
            />
            
            <Button
              color="primary"
              variant="contained"
              onClick={ () => onClickFindModem(modemSerialNo, deviceSerialNo, selectedTelecom, selectedStatus, selectedInstalled) }
            >
              조회
            </Button>
          
          </div>

          <div className={classes.row}>

            <Typography
              className={classes.registerListNameTitle}
              color="textSecondary"
              gutterBottom
            >
              디바이스 시리얼 NO
            </Typography>

            <SearchInput
              className={classes.searchInput}
              placeholder=""
              value={deviceSerialNo}
              onChange={event => setDeviceSerialNo(event.target.value)}
            />

          </div>

          <div className={classes.row}>

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              통신회사
            </Typography>
            <TextField
              className={classes.registerListItemInput}
              id="outlined-find-telecom"
              value={selectedTelecom}
              onChange={e=> setSelectedTelecom(e.target.value)}
              helperText=""
              //variant="outlined"
              margin="dense"
            />

          </div>

          <div className={classes.row}>

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              모뎀상태
            </Typography>
            <TextField
              className={classes.registerListItemInput}
              id="outlined-select-client"
              select
              value={selectedStatus}
              onChange={event=> setSelectedStatus(event.target.value)}
              helperText=""
              //variant="outlined"
              margin="dense"
            >
              {statusesDevice.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>

            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              모뎀 현황
            </Typography>
            <TextField
              className={classes.registerListItemInput}
              id="outlined-select-client"
              select
              value={selectedInstalled}
              onChange={event=> setSelectedInstalled(event.target.value)}
              helperText=""
              //variant="outlined"
              margin="dense"
            >
              {typesDevice.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>

          </div>

        </div>
      )}

      {type === 'mhistory' && (
        <div>
          <div className={classes.row}>

            <Typography
              className={classes.registerListNameTitle}
              color="textSecondary"
              gutterBottom
            >
              모뎀 시리얼 NO
            </Typography>

            <SearchInput
              className={classes.searchInput}
              placeholder=""
              value={modemSerialNo}
              onChange={event => setModemSerialNo(event.target.value)}
            />
            
            <Button
              color="primary"
              variant="contained"
              onClick={ () => onClickFindModemHistory(modemSerialNo) }
            >
              조회
            </Button>
          
          </div>

          <div className={classes.row}>


            <Typography
              className={classes.registerListItemTitle}
              color="textSecondary"
              gutterBottom
            >
              조회일자
            </Typography>

            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                id="date-picker-inline11"
                value={selectedStartDate}
                onChange={date => setSelectedStartDate(date)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />

              <Typography
                className={classes.registerListItemDateGap}
                color="textSecondary"
                gutterBottom
              >
                ~
              </Typography>

              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                id="date-picker-inline12"
                value={selectedEndDate}
                onChange={date => setSelectedEndDate(date)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />

            </MuiPickersUtilsProvider>

            </div>

            { userRole !== 'user' && (
              <div className={classes.row}>

              <Typography
                className={classes.registerListItemTitle}
                color="textSecondary"
                gutterBottom
              >
                일괄삭제
              </Typography>

              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>

                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  id="date-picker-inline13"
                  value={selectedDeleteStartDate}
                  onChange={date => setSelectedDeleteStartDate(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />

                <Typography
                  className={classes.registerListItemDateGap}
                  color="textSecondary"
                  gutterBottom
                >
                  ~
                </Typography>

                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="dense"
                  id="date-picker-inline14"
                  value={selectedDeleteEndDate}
                  onChange={date => setSelectedDeleteEndDate(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />

              </MuiPickersUtilsProvider>

              <Button
                style={{
                //  borderRadius: 35,
                  backgroundColor: "#E00000",
                  color: "#FFFFFF"
                  // padding: "18px 36px",
                  // fontSize: "18px"
                }}
                variant="contained" 
                //color="inherit"
                onClick={ () => onClickDeleteAllModemHistory(selectedDeleteStartDate, selectedDeleteEndDate) }
              >
                삭제
              </Button>
            </div>
            )}
        </div>
      )}
    </div>

  );
};

DeviceToolbar.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string
};

export default DeviceToolbar;
